import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlPagamentos = '/service/contabilidade/ordemCronologicaPortal/'

class PagamentosService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getPagamentos() {
        return this.conex.get(urlPagamentos + 'pagamentoFilas/')
    }
}

export default PagamentosService
